// chatbotReducer.js
import { CHATBOT_ACTIONS } from "../../actions/chatbotActions/chatbotActionTypes";

const initialState = {
  loading: false,
  result: null,
  error: null,
};

const brandidReducers = (state = initialState, action) => {
  switch (action.type) {
    case CHATBOT_ACTIONS.CHECK_BRAND_DS_REQUEST:
      return { ...state, loading: true, error: null };
    case CHATBOT_ACTIONS.CHECK_BRAND_DS_SUCCESS:
      return { ...state, loading: false, result: action.payload };
    case CHATBOT_ACTIONS.CHECK_BRAND_DS_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default brandidReducers;
